<template>
  <v-container
    fluid
    class="ma-0 pa-0"
  >
    <!-- ここから。ナビゲーションバー -->
    <v-progress-linear value="100" />
    <v-bottom-navigation
      dense
      class="ma-0 pa-0"
      height="45px"
      color="bule"
    >
      <v-col
        cols="2"
        class="ma-0 pa-0 pt-1 pl-2"
      >
        <v-select
          v-model="modeType.selected"
          :items="modeType.type"
          label="mode"
          dense
          outlined
        />
      </v-col>

      <v-btn
        :loading="$store.state.partAnalysis.isLoadingFlg"
        x-small
        @click="analyseSample"
      >
        <span>sample</span>
        <v-icon color="red">
          mdi-book-open
        </v-icon>
      </v-btn>

      <v-btn
        :loading="$store.state.partAnalysis.isLoadingFlg"
        x-small
        @click="$store.commit('partAnalysis/analyseDoc', $store.state.memNowDoc); $store.commit('partAnalysis/reDisplay')"
      >
        <span>re-analyse</span>
        <v-icon color="#769fcd">
          mdi-cached
        </v-icon>
      </v-btn>

      <v-btn
        :loading="$store.state.partAnalysis.isLoadingFlg"
        x-small
        @click="docCopy"
      >
        <span> doc-copy </span>

        <v-icon color="#769fcd">
          mdi-file-document-outline
        </v-icon>
      </v-btn>

      <v-col
        cols="1"
        class="ma-0 pa-0 pt-1 pl-2"
      >
        <v-select
          v-model="fontsizeQl.selected"
          :items="fontsizeQl.type"
          label="fontsize"
          dense
          outlined
        />
      </v-col>

      <v-spacer />

      <v-btn
        x-small
        @click="output"
      >
        <span>output</span>
        <v-icon color="#769fcd">
          mdi-export-variant
        </v-icon>
      </v-btn>

      <v-col
        cols="2"
        class="ma-0 pa-0 pt-1 pr-3"
      >
        <v-select
          v-model="outputType.selected"
          :items="outputType.type"
          label="Output type"
          dense
          outlined
        />
      </v-col>
    </v-bottom-navigation>

    <!--ここまで。ナビゲーションバー-->
    <v-row class="ma-0 pa-0">
      <v-col
        class="ma-0 pa-1"
        cols="6"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <!--テキストエディター-->
          <quill-editor
            ref="quillEditor"
            v-model="$store.state.dspEditDoc"
            spellcheck="false"
            :style="{ display: $store.state.isDisplayDoc }"
            :options="editorOption"
            style="height:100%;"
            @change="onEditorChange($event)"
          />
        </v-card>
      </v-col>
      <v-col
        class="ma-0 pa-0"
        cols="6"
      >
        <!-- <dual-editor v-if="dualEditorMode==true" /> -->
        <partarea v-if="modeType.selected=='品詞'" />
        <patent v-if="modeType.selected=='出願'" />
        <office-action v-if="modeType.selected=='拒絶'" />
      </v-col>
    </v-row>
    <!-- ここから。特許明細書の図・数式の挿入失敗用のダイアログ -->
    <v-dialog
      v-model="figureFail"
      max-width="500px"
    >
      <v-card>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="8"
            >
              <v-chip
                class="ma-2"
                color="red"
                outlined
                large
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                カーソルが文章中にありません。
              </v-chip>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                class="ma-3 pa-0"
                right
                @click="figureFail = !figureFail"
              >
                閉じる
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- ここまで。特許明細書の図・数式の挿入失敗用のダイアログ -->
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import VueQuillEditor from 'vue-quill-editor'
  import sampleJs from './sample.js'
  import 'quill/dist/quill.bubble.css'
  import 'quill/dist/quill.snow.css'
  import Partarea from './Part'
  import Patent from './Patent'
  import OfficeAction from './OfficeAction'
  // import DualEditor from './DualEditor'
  // import { ImageDrop } from 'quill-image-drop-module'

  Vue.use(VueQuillEditor)
  // VueQuillEditor.register('modules/imageDrop', ImageDrop)

  export default {
    components: { Partarea, Patent, OfficeAction },

    data: () => ({
      modeType: { type: ['品詞', '出願', '拒絶'], selected: '品詞' },
      outputType: { type: ['text', 'HTML出願用', 'HTML_UTF-8'], selected: 'HTML出願用' },
      editorOption: {
        modules: {
          toolbar: false,
        },
      },
      figureFail: false,
      fontsizeQl: { type: ['10', '11', '12', '13', '14', '15', '16', '17'], selected: '14' },
    }),

    computed: {
      watchDark () { return this.$vuetify.theme.dark },
      watchImageExert () { return this.$store.state.watchImage },
    },

    watch: {
      watchImageExert () {
        // 図のイメージタグの貼り付けと例外が発生した場合、ダイアログを表示
        try {
          this.$refs.quillEditor.quill.insertText(this.$refs.quillEditor.quill.getSelection().index, '<img src="' + this.$store.state.watchImage + '"/>', '', true)
        } catch (error) { this.figureFail = true }
      },
      watchDark () {
        this.$store.state.darkTheme = this.$vuetify.theme.dark
        const tds = document.querySelectorAll('.ql-editor > p > span')
        for (var i = 0; i < tds.length; i++) tds[i].style.backgroundColor = (this.$vuetify.theme.dark) ? '#0000CC' : '#CCFFCC'
      },
      fontsizeQl: {
        handler: function (val, oldVal) { document.getElementsByClassName('ql-container').item(0).style.fontSize = this.fontsizeQl.selected + 'px' },
        deep: true,
      },
      modeType: {
        handler: function (val, oldVal) {
          this.$store.commit('partAnalysis/checkReset')
          this.$store.commit('changeEdtorHTML', this.$store.state.memNowDoc)
        },
        deep: true,
      },
    },

    created () { this.$store.commit('partAnalysis/torken', null) },

    methods: {
      onEditorChange ({ html, text }) {
        this.$store.state.memNowDoc = unescape(escape(text).replace(/%A0/g, '%u0020').replace(/%09/g, '%u0020'))
        this.$store.state.memNowHTML = html
      },

      analyseSample () {
        if (this.modeType.selected === '拒絶') {
          this.$store.commit('changeEdtorHTML', sampleJs.OfficeAction())
        } else {
          this.$store.commit('partAnalysis/checkReset')
          this.$store.commit('partAnalysis/analyseDoc', sampleJs.samplePatent())
          this.$store.commit('partAnalysis/reDisplay')
        }
      },

      docCopy () {
        var str = this.$store.state.memNowDoc
        // var listener = function (e) {
        //   e.clipboardData.setData('text/plain', str)
        //   // 本来のイベントをキャンセル
        //   e.preventDefault()
        //   // 終わったら一応削除
        //   document.removeEventListener('copy', listener)
        // }
        // // コピーのイベントが発生したときに、クリップボードに書き込むようにしておく
        // document.addEventListener('copy', listener)
        // document.execCommand('copy')
        navigator.clipboard.writeText(str).then(e => {
          alert('クリップボードに文章をコピーしました。')
        })
      },

      output () {
        const encoding = require('encoding-japanese')
        const keyword = this.$store.state.memNowHTML.replace(/<\/p>/g, '</p>\n').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        // キーワードを文字コードの数値の配列に変換
        const unicodeArray = []
        for (let i = 0; i < keyword.length; i++) { unicodeArray.push(keyword.charCodeAt(i)) }
        // Shift_JISに変換
        const sjisArray = encoding.convert(unicodeArray, {
          to: 'SJIS',
          from: 'UNICODE',
        })
        const afString = new Uint8Array(sjisArray)
        // 出力データの選定
        const outputdata = (this.outputType.selected === 'text') ? this.$store.state.memNowDoc
          : (this.outputType.selected === 'HTML出願用') ? afString
            : (this.outputType.selected === 'HTML_UTF-8') ? keyword
              : ''
        const blob = new Blob([outputdata], { type: 'text/plan' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = (this.outputType.selected === 'text') ? 'checkdoc.txt' : (this.outputType.selected === 'HTML出願用' || this.outputType.selected === 'HTML_UTF-8') ? 'checkdoc.html' : ''
        link.click()
      },
    },
    head: {
      meta: [
        { name: 'description', content: 'Document Checker -特許明細書-は、特許明細書の作成に特化した無料の文書チェックアプリです。品詞の解析、特許明細書の校正が可能です。使い方はHowToをご覧ください。なお、利用規約を守ってご利用ください。' },
        { property: 'og:title', content: 'Document Checker - 特許明細書 -' },
        { property: 'og:description', content: 'Document Checker -特許明細書-は、特許明細書の作成に特化した無料の文書チェックアプリです。品詞の解析、特許明細書の校正が可能です。使い方はHowToをご覧ください。なお、利用規約を守ってご利用ください。' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://document-checker-project.web.app' },
        { property: 'og:image', content: 'https://document-checker-project.web.app/favicon.ico' },
        { name: 'twitter:card', content: 'summary' },
      ],
    },
  }
</script>

<style>
</style>
